module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "Sandra-Koehldorfer.0b0b4314.jpeg" + "?" + Date.now();